import Signup from './Signup.page';

export default Signup;
